// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1RFO_","header":"styles_header__1czuW","button":"styles_button__4kSW1","cancel":"styles_cancel__3z-A1"};